import React, { useEffect } from 'react';
import { compose } from 'redux';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import BuildQueryReducer from './BuildQueryReducer';
import { buildQueryReducerKey } from './BuildQueryConstants';
import BuildQuery from './BuildQuery';
import {
  query as querySelector,
  isFormsButtonsEnabled as isFormsButtonsEnabledSelector,
  isClassicLicense as isClassicLicenseSelector,
  structurePreview as structurePreviewSelector,
  previewSize as previewSizeSelector,
  dbs as dbsSelector,
  qsForms as qsFormsSelector,
} from './BuildQuerySelectors';

import {
  initialize,
  searchByQuery,
  clearStructure,
  saveResults,
  goToQueryBuilderForm,
  populateQuickSearch,
  updateInputText,
  showImportModal,
  showStructurePopup,
  goToStructure,
} from './BuildQueryActions';
import { withCombinedRouteParams } from '../../../../AppRoutes/ConnectedRoute';

const mapStateToProps = (state) => ({
  query: querySelector(state),
  isFormsButtonsEnabled: isFormsButtonsEnabledSelector(state),
  isClassicLicense: isClassicLicenseSelector(state),
  structurePreview: structurePreviewSelector(state),
  previewSize: previewSizeSelector(state),
  dbs: dbsSelector(state),
  qsForms: qsFormsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  initialize: () => dispatch(initialize()),
  searchByQuery: () => dispatch(searchByQuery()),
  clearStructure: () => dispatch(clearStructure()),
  saveResults: () => dispatch(saveResults()),
  goToQueryBuilderForm: (form) => dispatch(goToQueryBuilderForm(form)),
  populateQuickSearch: (populatedTerm) => dispatch(populateQuickSearch(populatedTerm)),
  updateInputText: (value) => dispatch(updateInputText(value)),
  showImportModal: () => dispatch(showImportModal()),
  showStructurePopup: () => dispatch(showStructurePopup()),
  goToStructure: () => dispatch(goToStructure()),
});

function BuildQueryontainer(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <BuildQuery {...props} />;
}

export default compose(
  withCombinedRouteParams,
  withReducer(buildQueryReducerKey, BuildQueryReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(BuildQueryontainer);
